import React from 'react';
import Character from './Character';
import BeatIndicators from './BeatIndicators';
import TempoControl from './TempoControl';
import TimeSigControl from './TimeSigControl';
import { useLanguage } from '../contexts/LanguageContext';

const MetronomeSection = ({
  isPlaying,
  tempo,
  beatsPerMeasure,
  count,
  beatAccents,
  currentCharacter,
  currentColor,
  currentAccessory,
  practiceTime,
  totalPracticeTime,
  onToggleMetronome,
  onTempoChange,
  onTimeSigChange,
  onToggleBeatAccent
}) => {
  const { t } = useLanguage();

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  const shouldShowCharacterActive = isPlaying && beatAccents[count];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <div className="space-y-6">
          <div className="bg-white dark:bg-gray-800 rounded-3xl p-6 shadow-xl">
            <Character
              character={currentCharacter}
              color={currentColor}
              accessory={currentAccessory}
              isActive={shouldShowCharacterActive}
            />
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-3xl p-6 shadow-xl">
            <BeatIndicators
              beatsPerMeasure={beatsPerMeasure}
              currentBeat={count}
              beatAccents={beatAccents}
              onToggleBeatAccent={onToggleBeatAccent}
            />
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-white dark:bg-gray-800 rounded-3xl p-6 shadow-xl">
            <div className="space-y-6">
              <TempoControl tempo={tempo} onTempoChange={onTempoChange} />
              <TimeSigControl beatsPerMeasure={beatsPerMeasure} onTimeSigChange={onTimeSigChange} />
              <button
                onClick={onToggleMetronome}
                className={`w-full py-4 px-8 rounded-2xl font-bold text-xl transition-all duration-200 transform hover:scale-105 ${
                  isPlaying
                    ? 'bg-gradient-to-r from-red-500 to-pink-500 text-white shadow-lg'
                    : 'bg-gradient-to-r from-green-500 to-blue-500 text-white shadow-lg'
                }`}
              >
                {isPlaying ? `⏸️ ${t('stop')}` : `▶️ ${t('start')}`}
              </button>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-3xl p-6 shadow-xl">
            <h3 className="text-lg font-semibold mb-4 text-center text-gray-700 dark:text-gray-300">
              📊 {t('practiceStats')}
            </h3>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-xl p-4 text-center">
                <p className="text-sm opacity-90 mb-1">{t('currentSession')}</p>
                <p className="text-xl font-bold">{formatTime(practiceTime)}</p>
              </div>
              <div className="bg-gradient-to-r from-green-500 to-blue-500 text-white rounded-xl p-4 text-center">
                <p className="text-sm opacity-90 mb-1">{t('totalTime')}</p>
                <p className="text-xl font-bold">{formatTime(totalPracticeTime)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetronomeSection;